// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3aGVv","consentsList":"PatientConsents_consentsList__3i0uh","consentsListEmpty":"PatientConsents_consentsListEmpty__2v28T"};